import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TApplicationState } from '../../../libs/store';
import { actions as RecruitmentActions } from '../modules';
import apiService from '../../../services/apiService';

const useRecentRecruitmentProfiles = (region: string) => {
  const dispatch = useDispatch();
  const recentlyPublishedProfiles: any = useSelector(
    ({ recruitment }: TApplicationState) => recruitment.recentlyPublishedProfiles
  );

  useEffect(() => {
    if (recentlyPublishedProfiles.loaded || recentlyPublishedProfiles.loading) {
      return;
    }

    const loadQueryParams: any = {
      limit: 8,
      region
    };

    dispatch(RecruitmentActions.loadRecentlyPublishedProfiles());

    apiService.getRecentRecruitmentProfiles(loadQueryParams, (err, data) => {
      if (err) {
        dispatch(RecruitmentActions.loadRecentlyPublishedProfilesFailure());
      } else {
        dispatch(RecruitmentActions.loadRecentlyPublishedProfilesSuccess(data.profiles));
      }
    });
  }, [recentlyPublishedProfiles]);

  return recentlyPublishedProfiles;
};

export default useRecentRecruitmentProfiles;
